import React, { useMemo } from "react";

import { buildFontFaceCss } from "@/src/utils/fontFaces";

import type { JSX } from "react";

import type { FontFamily } from "@/src/api/StylesAPI.types";

interface FontFaceStylesProps {
  familyList: FontFamily[];
}

function FontFaceStyles({
  familyList,
}: FontFaceStylesProps): JSX.Element | null {
  const css = useMemo(() => buildFontFaceCss(familyList), [familyList]);

  if (!css) return null;

  return <style>{css}</style>;
}

export default FontFaceStyles;
